<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <app-title [titles]="[title()]" class="title" />
      </div>
      @if (dataLoaded()) {
        <div class="col-lg-7 col-xs-12 content">
          <p class="paragraph">
            Votre agenceur {{ store() }} aura le plaisir de vous rencontrer pour échanger sur votre projet le
            {{ date() | date: "d MMMM y" }}, à {{ date() | date: "HH:mm" }}.
          </p>
          <p class="paragraph">
            Un email vous parviendra prochainement avec toutes les informations nécessaires à ce premier rendez-vous.
          </p>
          @if (showAccountPush()) {
            <p class="paragraph">
              Vous pouvez désormais
              <button (click)="login(true)" class="link" type="button">créer un compte</button>
              Perene vous permettant de préparer ce rendez-vous et de le gérer.
            </p>
          }
          <p class="paragraph">À très bientôt.</p>
          @switch (showAccountPush()) {
            @case (true) {
              <div class="buttons">
                <app-button
                  (buttonClicked)="login(true)"
                  [icon]="{ name: 'CHEVRON_RIGHT', color: 'BLACK' }"
                  [theme]="'WHITE'"
                  class="button"
                  label="Créer un compte" />
                <app-button
                  (buttonClicked)="login(false)"
                  [icon]="{ name: 'CHEVRON_RIGHT', color: 'WHITE' }"
                  [theme]="'TRANSPARENT_WHITE'"
                  label="Se connecter" />
              </div>
            }
            @case (false) {
              <div class="buttons">
                <app-button
                  [icon]="{ name: 'CHEVRON_RIGHT', color: 'BLACK' }"
                  [theme]="'WHITE'"
                  [url]="'/projets'"
                  class="button"
                  label="Les intérieurs de nos clients" />
                <app-button
                  [icon]="{ name: 'CHEVRON_RIGHT', color: 'WHITE' }"
                  [theme]="'TRANSPARENT_WHITE'"
                  [url]="'/charte-dengagements-perene'"
                  label="Notre charte d’engagement" />
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</section>
